import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DownloadIconComponent } from '../../../icons/download-icon/download-icon.component';
import { IfPolicySatisfiedDirective } from '../../../../directives/if-policy-satisfied.directive';
import { Policy } from '../../../../../shared/models/info/policy';
import { SwPartNumber } from '../../../../../shared/models/sw-part-number/sw-part-number';
import { initFlowbite } from 'flowbite';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { WrenchIconComponent } from '../../../icons/wrench-icon/wrench-icon.component';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';
import { CloudArrowUpIconComponent } from '../../../icons/cloud-arrow-up-icon/cloud-arrow-up-icon.component';

@Component({
  selector: 'app-export-popover',
  imports: [
    DownloadIconComponent,
    IfPolicySatisfiedDirective,
    CloseIconComponent,
    WrenchIconComponent,
    AgentActionDirective,
    CloudArrowUpIconComponent,
  ],
  templateUrl: './export-popover.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './export-popover.scss',
})
export class ExportPopover implements AfterViewInit {
  @Input() public swPartNumber?: SwPartNumber;
  @Output() public swPartNumberDownloadClicked = new EventEmitter<SwPartNumber>();
  @Output() public swPartNumberDocDownloadClicked = new EventEmitter<SwPartNumber>();
  @Output() public resetOnTerminalExportedClicked = new EventEmitter<SwPartNumber>();
  @Output() public resetDocumentationExportedClicked = new EventEmitter<SwPartNumber>();
  @Output() public publishEventsClicked = new EventEmitter<SwPartNumber>();

  protected readonly popoverTargetId = `export-popover-${crypto.randomUUID()}`;
  protected readonly policy = Policy;
  protected isOpen = false;

  public ngAfterViewInit(): void {
    initFlowbite();
  }
}
